import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();

type RemountHandler = () => void;

let remountHandler: RemountHandler | null = null;

export const registerAppRemountHandler = (handler: RemountHandler): void => {
    remountHandler = handler;
};

/**
 * Полный ремаунт SPA-дерева и сброс кэша react-query без обращения
 * к window.location. Используется там, где настоящая навигация/reload
 * может быть перехвачена хостом (см. floatingReloadButton) и уведена
 * из приложения — здесь всё происходит внутри JS, без HTTP-перехода.
 */
export const softReloadApp = (): void => {
    queryClient.clear();
    remountHandler?.();
};
